import React from 'react';
import { Input, Select, DatePicker, Button } from 'antd';
import {
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

const { Option } = Select;
const { RangePicker } = DatePicker;

const MODULES = [
  'User Management',
  'Transactions',
  'KYC',
  'Loan Management',
  'Settings',
  'Products',
  'Bills Payment',
  'Cards',
  'Disbursement',
  'Authentication',
];

const ACTION_TYPES = [
  'Login',
  'Updated User Account',
  'Approved KYC',
  'Changed System Settings',
  'Approved Product Subscription',
  'Modified Commission Rate',
  'Created Admin User',
  'Disabled User Account',
  'Fund Transfer',
  'Bill Payment',
  'Loan Application',
  'Profile Update',
  'Card Request',
  'Password Change',
];

const ActivityLogFilters = ({
  filters,
  onFilterChange,
  onApply,
  onReset,
  hideUserType = false,
  hideLoginStatus = false,
}) => {
  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      onFilterChange({
        ...filters,
        startDate: dates[0]?.format('YYYY-MM-DD'),
        endDate: dates[1]?.format('YYYY-MM-DD'),
      });
    } else {
      onFilterChange({ ...filters, startDate: null, endDate: null });
    }
  };

  return (
    <div className="activity-filter-bar">
      <div className="activity-filter-row">
        {/* Search */}
        <div className="activity-filter-item filter-search">
          <span className="activity-filter-label">Search</span>
          <Input
            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
            placeholder="Username, account number, action…"
            allowClear
            value={filters.search}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </div>

        {/* Module */}
        <div className="activity-filter-item">
          <span className="activity-filter-label">Module</span>
          <Select
            placeholder="All Modules"
            allowClear
            value={filters.module || undefined}
            onChange={(val) => handleChange('module', val)}
          >
            {MODULES.map((m) => (
              <Option key={m} value={m}>
                {m}
              </Option>
            ))}
          </Select>
        </div>

        {/* User Type */}
        {!hideUserType && (
          <div className="activity-filter-item">
            <span className="activity-filter-label">User Type</span>
            <Select
              placeholder="All Types"
              allowClear
              value={filters.userType || undefined}
              onChange={(val) => handleChange('userType', val)}
            >
              <Option value="ADMIN">Admin</Option>
              <Option value="CUSTOMER">Customer</Option>
            </Select>
          </div>
        )}

        {/* Action Type */}
        <div className="activity-filter-item">
          <span className="activity-filter-label">Action Type</span>
          <Select
            placeholder="All Actions"
            allowClear
            value={filters.actionType || undefined}
            onChange={(val) => handleChange('actionType', val)}
          >
            {ACTION_TYPES.map((a) => (
              <Option key={a} value={a}>
                {a}
              </Option>
            ))}
          </Select>
        </div>

        {/* Login Status */}
        {!hideLoginStatus && (
          <div className="activity-filter-item">
            <span className="activity-filter-label">Login Status</span>
            <Select
              placeholder="All"
              allowClear
              value={filters.loginStatus || undefined}
              onChange={(val) => handleChange('loginStatus', val)}
            >
              <Option value="SUCCESS">Success</Option>
              <Option value="FAILED">Failed</Option>
            </Select>
          </div>
        )}

        {/* Date Range */}
        <div className="activity-filter-item">
          <span className="activity-filter-label">Date Range</span>
          <RangePicker
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            style={{ width: '100%' }}
          />
        </div>

        {/* Actions */}
        <div className="activity-filter-actions">
          <Button
            icon={<FilterOutlined />}
            onClick={onApply}
            className="activity-filter-apply-btn"
          >
            Filter
          </Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={onReset}
            className="activity-filter-reset-btn"
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ActivityLogFilters;
